import { api } from '../../lib/api-client';

/**
 * 0 = Independent (self-reported, sin badge).
 * 1 = WorkspaceInternal ("Verificado por [Workspace]" badge).
 * Espejo de `Scouting.Model.WorkExperienceProvenance`.
 */
export type WorkExperienceProvenance = 0 | 1;

export type WorkExperienceItem = {
  /** `WorkExperience.PublicKey` Guid. */
  id: string;
  companyName: string;
  role: string;
  /** ISO datetime. */
  startDate: string;
  /** ISO datetime, o null cuando es la posición actual. */
  endDate: string | null;
  description: string | null;
  provenance: WorkExperienceProvenance;
  /** Solo para `WorkspaceInternal`; null para `Independent`. */
  workspaceClientIndustry: string | null;
  /**
   * SW-149: highlights expandibles del rol — newline-separated string. El FE hace
   * split por `\n` y renderiza una <ul> oculta detrás del toggle "See more / See
   * less". Null o vacío → no se renderiza la sección ni el toggle.
   */
  highlights: string | null;
};

export type WorkExperiencesResponse = {
  items: WorkExperienceItem[];
};

export type GetTalentExperiencesParams = {
  shortlistPublicKey: string;
  talentPublicKey: string;
};

export async function getTalentExperiences(
  params: GetTalentExperiencesParams,
): Promise<WorkExperiencesResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/experiences`;
  return api.get<WorkExperiencesResponse>(url);
}
